import { combineReducers } from 'redux';
import { bodyGradientReducer, borderRadiusReducer, boxLayoutReducer, iconColorReducer, monochromeReducer, strokeReducer, themeModeReducer, themeReducer, cardShadowReducer, sidebarDarkReducer, headerDarkReducer } from './settingsReducers';
import userReducer from './userReducer';
import tokenReducer from './token';
import MenuAccess from './MenuAccessReducers';
import MenuListReducer from './MenuListReducers';

const rootReducer = combineReducers({
    themeMode: themeModeReducer,
    theme: themeReducer,
    stroke: strokeReducer,
    boxLayout: boxLayoutReducer,
    monochrome: monochromeReducer,
    borderRadius: borderRadiusReducer,
    iconColor: iconColorReducer,
    gradientColor: bodyGradientReducer,
    cardShadow: cardShadowReducer,
    sidebarDark: sidebarDarkReducer,
    headerDark: headerDarkReducer,
    user: userReducer,
    token: tokenReducer,
    menusaccess: MenuAccess,
    menulist: MenuListReducer
});

export default rootReducer;